
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$$;
      $$('.pay-lab-booking-btn').on('click', function () {
        var bookingId = $$(this).data('booking-id');
        app.methods.authHeader();
        app.preloader.show();
        app.request({
          url: app.data.remoteUrl + 'payments/initiate',
          method: 'POST',
          data: {
            type: 'lab_booking',
            lab_booking_id: bookingId
          },
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status && response.data) {
              response.data.description = 'Lab Test Booking';
              app.methods.razorpayCheckout(response.data, {
                onSuccess: function () {
                  app.dialog.alert('Payment successful!', 'mDOC', function () {
                    app.views.main.router.navigate('/lab-bookings/', { reloadCurrent: true });
                  });
                },
                onDismiss: function () {
                  app.views.main.router.navigate('/lab-bookings/', { reloadCurrent: true });
                }
              });
            } else {
              app.dialog.alert(response.msg || 'Payment not available', 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
    }
  },
  id: '56ff6bb611',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page lab-bookings-page" data-name="lab_bookings" id="labBookingsPage">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="/home/" class="link" aria-label="Back to home">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Lab Bookings</div>\n            </div>\n        </div>\n        <div class="page-content">\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.data.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="lab-bookings-list">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data.data, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="lab-booking-card-v2">\n                    <div class="lab-booking-card-v2-head">\n                        <div class="lab-booking-card-v2-icon">\n                            <i class="icon f7-icons if-not-md">testtube</i>\n                            <i class="icon material-icons md-only">biotech</i>\n                        </div>\n                        <div class="lab-booking-card-v2-info">\n                            <div class="lab-booking-card-v2-name">';
              r += c(ctx_3.lab_name, ctx_3);
              r += '</div>\n                            <div class="lab-booking-card-v2-meta">';
              r += c(ctx_3.patient_name, ctx_3);
              r += ' \xB7 ';
              r += c(ctx_3.test_count, ctx_3);
              r += ' test';
              r += Template7Helpers.js_if.call(ctx_3, 'parseInt(this.test_count) > 1', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 's';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '</div>\n                        </div>\n                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.is_paid == 1', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <span class="appt-status appt-status-confirmed">\n                            <i class="icon f7-icons if-not-md">checkmark_seal_fill</i>\n                            <i class="icon material-icons md-only">verified</i>\n                            Paid\n                        </span>\n                        ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <span class="appt-status appt-status-pending">\n                            <i class="icon f7-icons if-not-md">clock</i>\n                            <i class="icon material-icons md-only">schedule</i>\n                            Unpaid\n                        </span>\n                        ';
                  return r;
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </div>\n\n                    ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.tests_display, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                    <div class="lab-booking-card-v2-tests">';
                  r += c(ctx_4.tests_display, ctx_4);
                  r += '</div>\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n\n                    <div class="lab-booking-card-v2-foot">\n                        <div class="lab-booking-card-v2-date">\n                            <i class="icon f7-icons if-not-md">calendar</i>\n                            <i class="icon material-icons md-only">event</i>\n                            <span>';
              r += c(ctx_3.created_at, ctx_3);
              r += '</span>\n                        </div>\n                        <div class="lab-booking-card-v2-amount">\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.total_discount > 0', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                            <span class="lab-booking-card-v2-strike">&#8377;';
                  r += c(ctx_4.total_price, ctx_4);
                  r += '</span>\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                            <span class="lab-booking-card-v2-payable">&#8377;';
              r += c(ctx_3.payable_amt, ctx_3);
              r += '</span>\n                        </div>\n                    </div>\n\n                    ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.is_paid == 0 && this.payable_amt > 0', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                    <button class="lab-booking-card-v2-pay pay-lab-booking-btn" data-booking-id="';
                  r += c(ctx_4.id, ctx_4);
                  r += '" data-amount="';
                  r += c(ctx_4.payable_amt, ctx_4);
                  r += '">\n                        <i class="icon f7-icons if-not-md">creditcard_fill</i>\n                        <i class="icon material-icons md-only">payment</i>\n                        <span>Pay now \xB7 &#8377;';
                  r += c(ctx_4.payable_amt, ctx_4);
                  r += '</span>\n                    </button>\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <i class="icon f7-icons if-not-md" style="font-size: 56px; color: var(--mdoc-border);">testtube</i>\n                <i class="icon material-icons md-only" style="font-size: 56px; color: var(--mdoc-border);">biotech</i>\n                <div class="empty-state-title" style="margin-top: 14px;">No lab bookings yet</div>\n                <div class="empty-state-sub">Your lab test bookings will appear here.</div>\n                <a href="/pathlab/" class="empty-state-cta">\n                    <i class="icon f7-icons if-not-md">plus</i>\n                    <i class="icon material-icons md-only">add</i>\n                    <span>Book a lab test</span>\n                </a>\n            </div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    